/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActionSchedule } from './ActionSchedule';
import {
    ActionScheduleFromJSON,
    ActionScheduleFromJSONTyped,
    ActionScheduleToJSON,
    ActionScheduleToJSONTyped,
} from './ActionSchedule';

/**
 * 
 * @export
 * @interface ActionCreateRequest
 */
export interface ActionCreateRequest {
    /**
     * The type of this `Action`
     * @type {string}
     * @memberof ActionCreateRequest
     */
    actionType: ActionCreateRequestActionTypeEnum;
    /**
     * The value for this `Action` (e.g. phone number, URL)
     * @type {string}
     * @memberof ActionCreateRequest
     */
    actionValue?: string;
    /**
     * Additional properties for this `Action`
     * @type {{ [key: string]: string; }}
     * @memberof ActionCreateRequest
     */
    properties?: { [key: string]: string; };
    /**
     * The background color of the button
     * @type {string}
     * @memberof ActionCreateRequest
     */
    backgroundColor?: string;
    /**
     * Whether the icon is enabled
     * @type {boolean}
     * @memberof ActionCreateRequest
     */
    iconEnabled?: boolean;
    /**
     * The CSS class for the icon
     * @type {string}
     * @memberof ActionCreateRequest
     */
    iconClass?: string;
    /**
     * The color of the icon
     * @type {string}
     * @memberof ActionCreateRequest
     */
    iconColor?: string;
    /**
     * The text shown in the icon
     * @type {string}
     * @memberof ActionCreateRequest
     */
    iconText?: string;
    /**
     * The type of icon to use
     * @type {string}
     * @memberof ActionCreateRequest
     */
    iconType?: ActionCreateRequestIconTypeEnum;
    /**
     * URL of a background image for the icon
     * @type {string}
     * @memberof ActionCreateRequest
     */
    iconBackgroundImage?: string;
    /**
     * The background color of the label
     * @type {string}
     * @memberof ActionCreateRequest
     */
    labelBackgroundColor?: string;
    /**
     * The text shown in the label
     * @type {string}
     * @memberof ActionCreateRequest
     */
    labelText?: string;
    /**
     * Optional schedule for when this `Action` is active
     * @type {ActionSchedule}
     * @memberof ActionCreateRequest
     */
    schedule?: ActionSchedule;
}


/**
 * @export
 */
export const ActionCreateRequestActionTypeEnum = {
    Anchor: 'ANCHOR',
    Email: 'EMAIL',
    Hours: 'HOURS',
    Link: 'LINK',
    Map: 'MAP',
    Phone: 'PHONE',
    Sms: 'SMS',
    Whatsapp: 'WHATSAPP',
    Facebook: 'FACEBOOK',
    Signal: 'SIGNAL',
    Telegram: 'TELEGRAM',
    Iframe: 'IFRAME',
    Tally: 'TALLY',
    Intercom: 'INTERCOM',
    Skype: 'SKYPE',
    Zalo: 'ZALO',
    Viber: 'VIBER',
    Line: 'LINE',
    Wechat: 'WECHAT',
    Chat: 'CHAT',
    Booking: 'BOOKING'
} as const;
export type ActionCreateRequestActionTypeEnum = typeof ActionCreateRequestActionTypeEnum[keyof typeof ActionCreateRequestActionTypeEnum];

/**
 * @export
 */
export const ActionCreateRequestIconTypeEnum = {
    Default: 'DEFAULT',
    Custom: 'CUSTOM',
    Font: 'FONT',
    Svg: 'SVG',
    FontMaterial: 'FONT_MATERIAL'
} as const;
export type ActionCreateRequestIconTypeEnum = typeof ActionCreateRequestIconTypeEnum[keyof typeof ActionCreateRequestIconTypeEnum];


/**
 * Check if a given object implements the ActionCreateRequest interface.
 */
export function instanceOfActionCreateRequest(value: object): value is ActionCreateRequest {
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    return true;
}

export function ActionCreateRequestFromJSON(json: any): ActionCreateRequest {
    return ActionCreateRequestFromJSONTyped(json, false);
}

export function ActionCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'actionType': json['actionType'],
        'actionValue': json['actionValue'] == null ? undefined : json['actionValue'],
        'properties': json['properties'] == null ? undefined : json['properties'],
        'backgroundColor': json['backgroundColor'] == null ? undefined : json['backgroundColor'],
        'iconEnabled': json['iconEnabled'] == null ? undefined : json['iconEnabled'],
        'iconClass': json['iconClass'] == null ? undefined : json['iconClass'],
        'iconColor': json['iconColor'] == null ? undefined : json['iconColor'],
        'iconText': json['iconText'] == null ? undefined : json['iconText'],
        'iconType': json['iconType'] == null ? undefined : json['iconType'],
        'iconBackgroundImage': json['iconBackgroundImage'] == null ? undefined : json['iconBackgroundImage'],
        'labelBackgroundColor': json['labelBackgroundColor'] == null ? undefined : json['labelBackgroundColor'],
        'labelText': json['labelText'] == null ? undefined : json['labelText'],
        'schedule': json['schedule'] == null ? undefined : ActionScheduleFromJSON(json['schedule']),
    };
}

export function ActionCreateRequestToJSON(json: any): ActionCreateRequest {
    return ActionCreateRequestToJSONTyped(json, false);
}

export function ActionCreateRequestToJSONTyped(value?: ActionCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actionType': value['actionType'],
        'actionValue': value['actionValue'],
        'properties': value['properties'],
        'backgroundColor': value['backgroundColor'],
        'iconEnabled': value['iconEnabled'],
        'iconClass': value['iconClass'],
        'iconColor': value['iconColor'],
        'iconText': value['iconText'],
        'iconType': value['iconType'],
        'iconBackgroundImage': value['iconBackgroundImage'],
        'labelBackgroundColor': value['labelBackgroundColor'],
        'labelText': value['labelText'],
        'schedule': ActionScheduleToJSON(value['schedule']),
    };
}

